export default __webpack_public_path__ + "static/media/AHRQ-2-image.d7d051aa.jpg";